<template>
  <div class="item-box" @click="routerToDetail">
    <div class="title-line">
      <div class="title">{{pageData.xm}}的免实习申请</div>
      <div class="time">{{pageData.cjsj}}</div>
    </div>
    <div class="content">班级: {{pageData.bj}}</div>
    <div class="content">去向: {{pageData.qx}}</div>
    <div class="content"
         :style="{color: getStatusColor}">{{getStatusText}}</div>
  </div>
</template>

<script>
export default {
  props: {
    pageData: {
      type: Object,
      default: () => {
        return {
          bj: "机械设计1701",
          cjsj: "2022-02-25 15:53:48",
          iswfmes: "3",
          msxsqshid: "4D484E5A021049AD843DF55EC8D8CA86",
          qx: "当兵",
          xh: "17405701057",
          xm: "啟赖峥先",
        }
      },
    },
  },
  computed: {
    getStatusColor() {
      let list = ['#F85352', '#41B29C', '#FFA400', '#FFA400', '#F85352']
      return list[parseInt(this.pageData.iswfmes)]
    },
    getStatusText() {
      let list = ['未通过', '通过', '审核中', '待送审', '终止流程']
      return list[parseInt(this.pageData.iswfmes)]
    },
  },

  methods: {
    routerToDetail(){
      this.$router.push({
        path: '/internshipTeacher/applyStatus',
        query:{
          config: 1,
          id: this.pageData.msxsqshid
        }
      })
    }
  },
}
</script>

<style lang="less" scoped>
.item-box {
  width: 315px;
  background: #ffffff;
  border-radius: 8px;
  margin: 10px auto 0;
  padding: 12px 15px 14px 15px;
  .title-line {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 9px;
    .title {
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 18px;
      color: #333333;
    }
    .time {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #b2b2b2;
    }
  }
  .content {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/newPages/teacher/internship/components/freeApply.vue